import { render, staticRenderFns } from "./teamChatCreateGroupChat.vue?vue&type=template&id=220c092e&"
import script from "./teamChatCreateGroupChat.vue?vue&type=script&lang=js&"
export * from "./teamChatCreateGroupChat.vue?vue&type=script&lang=js&"
import style0 from "./teamChatCreateGroupChat.vue?vue&type=style&index=0&id=220c092e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports